import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import Marquee from "react-fast-marquee";
import { Link } from "react-router-dom";
import { CRYPTO_SECRET_KEY, URLS, SELECTED_PWA_STORAGE, STORAGE, SOCKET_URL, SOCKET_CHANNEL, SOCKET_TRANSPORTS } from "src/_config";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import { useAppEventAction } from "src/_common/hooks/actions/event/appEventActionHook";
import { toast } from "react-toastify";
import {
  useAppEventStatusMessageSelector,
  useAppGameLoginRequiredSelector,
} from "src/_common/hooks/selectors/eventSelector";
import { useAppUserDetailsSelector, useAppUserTokenSelector } from "src/_common/hooks/selectors/userSelector";
import PdfViewerModal from "../modal/pdfViewer";
import clsx from "clsx";
import { useCmsApi } from "src/_common/hooks/actions/cms/cmsApiHook";
import useSocket from "use-socket.io-client";
import OwlCarousel from "react-owl-carousel";

const Cryptr = require("cryptr");
const cryptr = new Cryptr(CRYPTO_SECRET_KEY);

export default function RodeoEventGamePage() {
  const eventApi = useEventApi();
  const cmsApi = useCmsApi();
  const history = useHistory();
  const userDetails = useAppUserDetailsSelector();
  const { eventId } = useParams<any>();
  const e_id: number = parseInt(cryptr.decrypt(eventId));
  const loginReq = useAppGameLoginRequiredSelector();
  const eventAction = useAppEventAction();
  const userToken = useAppUserTokenSelector();
  const [viewPdf, setViewPdf] = useState<boolean>(false);

  const [eventDetails, setEventDetails] = useState<any>(null);
  const [gameListData, setGameListData] = useState<any>([]);
  const [sponsorList, setSponsorList] = useState<any[]>([]);
  // const [cmsList, setCmsList] = useState<any>()
  const [eventMenus, setEventMenus] = useState<any>();
  const statusMessageSelector = useAppEventStatusMessageSelector();

  // const options = {
  //   nav: true,
  //   responsive: {
  //     0: {
  //       items: 1,
  //     },
  //     600: {
  //       items: 2,
  //     },
  //     1000: {
  //       items: 2,
  //     },
  //   }
  // }

  const openViewPdfModal = (e: any) => {
    e.preventDefault();
    if (!viewPdf) setViewPdf(true);
  };

  const closeViewPdfModal = () => {
    if (viewPdf) setViewPdf(false);
  };

  const getSponsorList = () => {
    eventApi.callGetSponsorList(
      (message: string, resp: any) => {
        if (resp && resp.list && resp.list.length) {
          setSponsorList(resp.list);
        } else {
          setSponsorList([]);
        }
      },
      (message: string) => {
        toast.error(message);
      }
    );
  };

  // const getCmsList = () => {
  //     let params = {
  //         game_id: e_id
  //     }

  //     cmsApi.callGameCms(params,
  //         (message: string, resp: any) => {
  //             if (resp && resp.list && resp.list.length) {
  //                 setCmsList(resp.list)
  //             }
  //         }, (message: string) => {
  //             toast.error(message)
  //         })
  // }

  const getEventGameList = () => {
    const params = {
      eventId: e_id,
    };
    eventApi.callGetEventGameList(
      params,
      (message: string, resp: any) => {
        if (resp && resp.event_details) {
          setEventDetails(resp.event_details);
        } else {
          setEventDetails(null);
        }

        if (resp && resp.list && resp.list.length) {
          setGameListData(resp.list);
        } else {
          setGameListData([]);
        }
      },
      (message: string) => {
        toast.error(message);
      }
    );
  };

  const goToPwaApplicationPage = (e: any, game: number, link: string) => {
    e.preventDefault();
    if (link != "#") {
      localStorage.setItem(SELECTED_PWA_STORAGE, link);
      let lr = gameListData.find((x: any) => x.id == game).login_required;
      console.log(lr);
      // let userToken=localStorage.getItem(STORAGE)
      if ((userDetails && userToken) || lr == 0) {
        if (link) {
          setTimeout(() => {
            window.open(link + `#token=${eventId}&userToken=${userToken}`, "_blank");
          }, 500);
          // window.open(link + `#token=${eventId}&userToken=${userToken}`, "_blank")
          // window.open(link + `#token=${eventId}`, "_blank")
        } else {
          history.push(`${URLS.HOME}`);
        }
      } else {
        let gameSlug = gameListData.find((x: any) => x.id == game).slug;
        localStorage.setItem("gameSlug", gameSlug);
        history.push(`${URLS.LOGIN}`);
      }
    }
  };

  const getMenus = () => {
    const params = {
      rodeo_event_id: e_id,
    };
    eventApi.callGetMenus(
      params,
      (message: string, resp: any) => {
        setEventMenus(resp);
      },
      (message: string) => {
        toast.error(message);
      }
    );
  };

  const openViewPdf = (e: any) => {
    window.open(eventDetails.rodeo_program.original);
  };

  useEffect(() => {
    getEventGameList();
    getSponsorList();
    // getCmsList()
    getMenus();
  }, []);

  const goToLeaderBoardPage = () => {
    history.push({
      pathname: URLS.EVENT.LEADERBOARD,
      state: { id: e_id },
    });
  };

  const gotoCmsPage = (slug: any) => {
    history.push(`/cms/${slug}`);
  };

  const [socket] = useSocket(SOCKET_URL, {
    autoConnect: false,
    withCredentials: true,
    transports: SOCKET_TRANSPORTS,
    upgrade: true,        // Enable transport upgrades (polling -> websocket)
    rememberUpgrade: true, // Remember successful upgrades for faster reconnection
  });

  useEffect(() => {
    socket.connect();

    socket.on(SOCKET_CHANNEL.GLOW_EVENT, (data: any) => {
      console.log({ data });
      setGameListData(data.list);
      if (data.event_details) {
        setEventDetails({
          ...eventDetails,
          rodeo_program: data.event_details.rodeo_program,
          rodeo_program_label: data.event_details.rodeo_program_label,
        });
      }
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  return (
    <React.Fragment>
      <div className="page-banner" style={{ marginTop: statusMessageSelector?.length ? "60px" : "0px" }}>
        {eventDetails?.banner?.id != 0 && eventDetails?.banner?.thumb && (
          <img src={eventDetails?.banner?.thumb} style={{ width: "100%" }} />
        )}
      </div>
      <div className="event-game-page">
        {/* <div className="logo-wrap-details">
                {eventDetails && eventDetails.avatar ?
                <img src={eventDetails && eventDetails.avatar ? eventDetails.avatar.original : '/images/logo.png'} alt="Logo" className="medium-logo" /> :null
                }
            </div> */}
        {/* <h2 className="page-title text-center justify-content-center led-box" onClick={() => {
                      goToLeaderBoardPage();
                    }}> */}
        {/* <Link to={URLS.EVENT.LEADERBOARD} className="back-history"> */}
        {/* Leaderboard */}
        {/* </Link> */}
        {/* </h2> */}
        {eventDetails && eventDetails.description ? (
          <div className="event-description text-center">{eventDetails.description}</div>
        ) : null}

        <div className="prog-list-wrapper-outer">
          <div className="prog-list-wrapper">
            {eventDetails && eventDetails.rodeo_program ? (
              <div className="prog-list">
                <Link to="#" className="prog-row" onClick={(e) => openViewPdfModal(e)}>
                  {/* <Link to="#" className="prog-row" onClick={(e) => openViewPdf(e)}> */}
                  <div className="prog-img">
                    <img src="/images/d1.png" alt="" />
                  </div>
                  {/* <div className="prog-name">Today's Rodeo Program</div> */}
                  <div className="prog-name">{eventDetails.rodeo_program_label || "Today's Rodeo Program"}</div>
                  <span>
                    <img src="/images/go.svg" />
                  </span>
                </Link>
              </div>
            ) : null}
            {/* <div className="prog-list"> */}
            {gameListData && gameListData.length
              ? gameListData.map((game: any, index: number) => (
                  <div className="prog-list" key={game.id}>
                    <a onClick={(e) => goToPwaApplicationPage(e, game.id, game.pwa_link)}>
                      <div
                        className={clsx({
                          "prog-row": game.glow_event === 0,
                          "prog-row glow": game.glow_event === 1,
                        })}
                      >
                        <div className="prog-img">
                          <img src={game.avatar ? game.avatar.original : "/images/no-image.png"} alt={game.name} />
                        </div>
                        <div className="prog-name">{game.tag_line}</div>
                        <span>
                          <img src="/images/go.svg" />
                          {/* <svg xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18" fill="none">
                                        <path d="M1.62312 0.666748H1.72739C1.897 0.679951 2.06763 0.712112 2.22099 0.788623C2.42106 0.881383 2.57848 1.0405 2.73083 1.19589C5.10027 3.56533 7.47006 5.93512 9.8395 8.30456C9.98271 8.4454 10.1286 8.58928 10.2224 8.76904C10.4001 9.10081 10.4083 9.51688 10.2437 9.85542C10.1195 10.1205 9.88622 10.3074 9.68784 10.5142C7.32279 12.8789 4.95809 15.2443 2.5927 17.6087C2.36622 17.8429 2.05375 17.9878 1.72705 18H1.67492C1.33232 17.9868 0.994791 17.8331 0.774739 17.5674C0.497136 17.2464 0.413178 16.7748 0.559428 16.3767C0.640677 16.1357 0.815703 15.9447 0.995468 15.7721C3.14182 13.6261 5.28884 11.4804 7.43451 9.33373C5.24991 7.14642 3.06226 4.96181 0.877317 2.77518C0.689766 2.58729 0.54724 2.34862 0.506954 2.08354C0.430782 1.66409 0.600053 1.21315 0.931484 0.945367C1.12479 0.780498 1.37328 0.695185 1.62312 0.666748Z" fill="black"/>
                                        </svg> */}
                        </span>
                      </div>
                    </a>
                  </div>
                ))
              : null}
            {/* </div> */}

            {/* {
                    cmsList && cmsList.length ? 
                        <div className='cms-wrap'>
                            <OwlCarousel className='owl-theme' nav items={3} >
                                {cmsList.map((cms: any) =>
                                    <div className="item" key={cms.id}>
                                        <a onClick={()=>gotoCmsPage(cms.id)}>
                                            {cms.title}
                                        </a>
                                    </div>
                                )}
                            </OwlCarousel>
                        </div>
                    : null
                } */}
            {eventDetails && eventDetails.link && eventDetails.link_label ? (
              <div className="prog-list">
                <Link to={{ pathname: eventDetails.link }} target="_blank" className="prog-row">
                  <div className="prog-img">
                    <img src="/images/d1.png" alt="" />
                  </div>
                  <div className="prog-name">{eventDetails.link_label}</div>
                  <span>
                    <img src="/images/go.svg" />
                  </span>
                </Link>
              </div>
            ) : null}
            {/* <div className="prog-list">
                        <a className="prog-row" onClick={()=>gotoCmsPage("fairgrounds")}>
                            <div className="prog-img">
                                <img src="/images/fairgrounds.jpg" alt="" />
                            </div>
                            <div className="prog-name">Fairgrounds</div>
                            <span>
                                <img src='/images/go.svg' />
                            </span>
                        </a>
                    </div> */}
            {/* <div className="prog-list">
                        <a className="prog-row" onClick={()=>gotoCmsPage("parking-map")}>
                            <div className="prog-img">
                                <img src="/images/parking-map.jpg" alt="" />
                            </div>
                            <div className="prog-name">Parking Map</div>
                            <span>
                                <img src='/images/go.svg' />
                            </span>
                        </a>
                    </div> */}
            {eventMenus?.length
              ? eventMenus?.map((menu: any) => (
                  <div className="prog-list">
                    {menu?.url_type == 2 ? (
                      <a href={menu?.url} target="_blank" className="prog-row">
                        <div className="prog-img">
                          <img src={menu?.avatar?.original} alt={menu?.name} />
                        </div>
                        <div className="prog-name">{menu?.name}</div>
                        <span>
                          <img src="/images/go.svg" />
                        </span>
                      </a>
                    ) : (
                      <a href={window.origin + "/" + menu?.url} className="prog-row">
                        <div className="prog-img">
                          <img src={menu?.avatar?.original} alt={menu?.name} />
                        </div>
                        <div className="prog-name">{menu?.name}</div>
                        <span>
                          <img src="/images/go.svg" />
                        </span>
                      </a>
                    )}
                  </div>
                ))
              : null}
            {/* <div className="prog-list">
                        <a href={'https://overunder.live/'} target="_blank"  className="prog-row" >
                            <div className="prog-img">
                                <img src="/images/CTA.jpg" alt="" />
                            </div>
                            <div className="prog-name">American Tickets</div>
                            <span>
                                <img src='/images/go.svg' />
                            </span>
                        </a>
                    </div>
                    <div className="prog-list">
                        <a href={'https://loremipsum.com/'} target="_blank"  className="prog-row" >
                            <div className="prog-img">
                                <img src="/images/am.jpg" alt="" />
                            </div>
                            <div className="prog-name">American Merch</div>
                            <span>
                                <img src='/images/go.svg' />
                            </span>
                        </a>
                    </div> */}
          </div>
        </div>
        {sponsorList && sponsorList.length ? (
          <div className="sponser-wrap d-none">
            <Marquee direction="left" loop={0} pauseOnHover={true} pauseOnClick={true} speed={40}>
              {sponsorList.map((sponsor: any, index: number) => (
                <Link to="#" key={sponsor.id} onClick={(e) => e.preventDefault()}>
                  <img src={sponsor.avatar.thumb} alt={sponsor.title} />
                </Link>
              ))}
            </Marquee>
          </div>
        ) : null}

        {viewPdf && (
          <PdfViewerModal
            shouldShow={viewPdf}
            onClose={closeViewPdfModal}
            url={eventDetails && eventDetails.rodeo_program ? eventDetails.rodeo_program : null}
          />
        )}
      </div>
      {/* <div className='footer-panel'>
                <p>© Copyright 2023 Inside Rodeo</p>
            </div> */}
    </React.Fragment>
  );
}
